(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-seo-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-seo-toggle]').forEach(function (btn) {
      var bodyId = btn.getAttribute('aria-controls');
      var body   = document.getElementById(bodyId);
      if (!body) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        body.classList.toggle('is-open', !isOpen);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
